


























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ZoomButtons",
  props: {
    value: { type: Number, required: true }
  },
  setup(props, context) {
    const MINIMUM_VALUE = 50;
    const MAXIMUM_VALUE = 150;

    const zoomIn = () => {
      context.emit("input", Math.min(props.value + 10, MAXIMUM_VALUE));
    };

    const zoomOut = () => {
      context.emit("input", Math.max(props.value - 10, MINIMUM_VALUE));
    };

    const reset = () => {
      context.emit("input", 100);
    };

    return { zoomIn, zoomOut, reset, MAXIMUM_VALUE, MINIMUM_VALUE };
  }
});
